import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuItem, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakInstance } from 'keycloak-js';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  isLoggedIn: boolean = false;
  userInformations: any;
  private keycloakAuth!: KeycloakInstance;

  
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu: NbMenuItem[] = [
    { 
      title: 'Profile',
      link: '/my-profile', // Optional: Add a link if you want to navigate to a specific route
      icon: 'person', // Optional: You can add an icon
    },
    {
      title: 'Log out',
      link: '/logout', // Optional: Add a link if you want to navigate to a specific route
      icon: 'log-out-outline' // Optional: You can add an icon
    },
  ];
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private readonly keycloak: KeycloakService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    // keycloak login status
    this.checkLoginStatus();
    this.checkLoginInformation();
  }

  checkLoginInformation(): void{
    this.keycloakAuth = this.keycloak.getKeycloakInstance();
    // Check if the user is authenticated before making the request
    if (this.keycloakAuth.authenticated) {
      // Get the token
      const token = this.keycloakAuth.token;
      this.isLoggedIn = true;
      console.log('ngOnInit HeaderComponent : this.keycloak.getToken() =>', token);
    }

    this.userInformations = this.isLoggedIn ? this.keycloakAuth.idTokenParsed : {};
    console.log('userInformations =>', this.userInformations);

  }

  checkLoginStatus(): void {
    this.isLoggedIn = this.keycloak.isLoggedIn();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  logout(): void {
    this.keycloak.logout();
  }
  
}
